// webpacker.ymlのresolved_pathsに指定したプレフィックスは省略可能

// Vue.js
import Vue from "vue/dist/vue.esm";

// /components
import VimeoMovie from "components/VimeoMovie.vue";
import CopyLink from "components/CopyLink.vue";

export default new Vue({
  el: "#vue-app",
  components: {
    VimeoMovie,
    CopyLink
  }
});
